import {
    GovSkeleton
} from "@gov-design-system-ce/react";
import {Variant} from "../Variant";

export enum SkeletonShape {
    RECT = "rect",
    CIRCLE = "circle",
    TEXT = "text"
}

export enum SkeletonAnimation {
    PULSE = "pulse",
    PROGRESS = "progress",
    FALSE = "false"
}

export interface SkeletonProps {
    variant?: Variant;
    shape?: SkeletonShape;
    animation?: SkeletonAnimation;
    count?: number;
}


export default function Skeleton(props: SkeletonProps) {
    const variant = props.variant ?? Variant.PRIMARY;
    const shape = props.shape ?? SkeletonShape.RECT;
    const animation = props.animation ?? SkeletonAnimation.PULSE;
    const count = props.count ?? 1;

    return (
        <GovSkeleton variant={variant}
                     shape={shape}
                     animation={animation}
                     count={count}>
        </GovSkeleton>
    );

}